import { ElementPropertyRulesRequestTypes } from './types';
import { ElementPropertyRulesActions } from './actions';
import {
  GetAllElementPropertyRulesResponse,
  ElementPropertyRuleRecord,
} from '@fullstory/proto/fs/services/search-settings';
import { createRequestReducer } from '@fullstory/redux-util';
import { combineReducers } from 'redux';

type State = Map<string, ElementPropertyRuleRecord>;

function elementPropertyRules(
  state: State = new Map<string, ElementPropertyRuleRecord>(),
  action: ElementPropertyRulesActions,
): State {
  switch (action.type) {
    case ElementPropertyRulesRequestTypes.ArchiveMultiElementPropertyRuleSuccess:
    // fallthrough
    case ElementPropertyRulesRequestTypes.UnarchiveMultiElementPropertyRuleSuccess:
    // fallthrough
    case ElementPropertyRulesRequestTypes.GetAllElementPropertyRulesSuccess: {
      const newState = new Map(state);
      action.data.elementPropertyRules.forEach(elementPropertyRule => {
        if (elementPropertyRule.elementPropertyRule?.id) {
          newState.set(elementPropertyRule.elementPropertyRule.id, elementPropertyRule);
        }
      });
      return newState;
    }
    case ElementPropertyRulesRequestTypes.SetElementPropertyRuleSuccess:
    // fallthrough
    case ElementPropertyRulesRequestTypes.ArchiveElementPropertyRuleSuccess:
    // fallthrough
    case ElementPropertyRulesRequestTypes.UnarchiveElementPropertyRuleSuccess: {
      const newState = new Map(state);
      if (action.data.elementPropertyRule?.elementPropertyRule?.id) {
        newState.set(
          action.data.elementPropertyRule.elementPropertyRule.id,
          action.data.elementPropertyRule,
        );
      }
      return newState;
    }
    default:
      return state;
  }
}

export const getAllElementPropertyRules =
  createRequestReducer<GetAllElementPropertyRulesResponse>()(
    ElementPropertyRulesRequestTypes.GetAllElementPropertyRulesRequest,
    ElementPropertyRulesRequestTypes.GetAllElementPropertyRulesSuccess,
    ElementPropertyRulesRequestTypes.GetAllElementPropertyRulesFailure,
  );

type ElementPropertyRulesReducerState = {
  elementPropertyRules: ReturnType<typeof elementPropertyRules>;
  getAllElementPropertyRules: ReturnType<typeof getAllElementPropertyRules>;
};

export const elementPropertyRulesReducer = combineReducers<ElementPropertyRulesReducerState>({
  elementPropertyRules,
  getAllElementPropertyRules,
});
